import { all, call, put, takeEvery } from 'redux-saga/effects';
import { logMesssage } from 'src/common/logging/logging-actions';
import { getErrorMessage } from 'src/utils/get-error-message';

import { checkoutActions } from './checkout-actions';
import { fetchIntent } from './checkout-api';
import { FetchIntentResponse } from './checkout-types';

export function* handleIntentFetchInitiated(action: { payload: string }) {
  try {
    const payload: FetchIntentResponse = yield call(
      fetchIntent,
      action.payload
    );

    yield put(
      checkoutActions.billingDetails.next.intentFetch.fulfilled(payload)
    );
  } catch (error) {
    const message: string = yield call(getErrorMessage, error);
    yield put(logMesssage(message));
  }
}

export function* checkoutSaga() {
  yield all([
    takeEvery(
      checkoutActions.billingDetails.next.intentFetch.initiated,
      handleIntentFetchInitiated
    ),
  ]);
}
